import { render, staticRenderFns } from "./WideCardLogoWithTitle.vue?vue&type=template&id=318703d0&"
import script from "./WideCardLogoWithTitle.vue?vue&type=script&lang=ts&"
export * from "./WideCardLogoWithTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports